module.exports = __webpack_public_path__ + "static/media/fingerprint-red.38434c4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/App/scenes/AppFrame/images/fingerprint-red.png
// module id = 564
// module chunks = 0